'use client';

// Third Party
import * as React from 'react';

// UI

import { Typography } from '@components/typography';
import { ExpandableText } from '@components/expandable-text';

type Props = { description: string };

export const Description: React.FC<Props> = ({ description }) => {
  return (
    <div
      className="-mb-2 space-y-2"
      data-testid="@listing/about-property-section"
    >
      <Typography
        component="h2"
        className="text-lg font-semibold"
        data-testid="@listing/about-property-title"
      >
        About The Property
      </Typography>

      <ExpandableText
        text={description}
        maxLines={8}
        testId="@listing/about-property"
        typographyVariant="body2"
        typographyVariantM="body2"
        className="text-primary-main !font-light "
        buttonColor="primary"
        buttonVariant="text"
        showMoreLabel="Show more"
        showLessLabel="Show less"
        buttonClassName="underline -ml-[16.5px] mt-1 font-medium text-md"
      />
    </div>
  );
};
